import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Modal as Modal$1 } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';
import { Icon } from '@grandvisionhq/icons';
import { useIntl } from '@grandvisionhq/state';
import { HeaderTextButton } from './HeaderTextButton.js';

const Modal = ({ children , footer , title , isOpen , headerTextButtonProps , showBackButton , additionalEventsWithBackIcon , showCloseButton , additionalEventsWithCloseButton , additionalEventsWithRandomAreaClick , onModalClose  })=>{
    const { getLabel  } = useIntl();
    const handleClickBackButton = ()=>{
        additionalEventsWithBackIcon === null || additionalEventsWithBackIcon === void 0 ? void 0 : additionalEventsWithBackIcon();
        onModalClose();
    };
    const handleClickCloseButton = ()=>{
        additionalEventsWithCloseButton === null || additionalEventsWithCloseButton === void 0 ? void 0 : additionalEventsWithCloseButton();
        onModalClose();
    };
    const handleOnClose = ()=>{
        additionalEventsWithRandomAreaClick === null || additionalEventsWithRandomAreaClick === void 0 ? void 0 : additionalEventsWithRandomAreaClick();
        onModalClose();
    };
    return /*#__PURE__*/ React.createElement(Modal$1, {
        className: "modal-secondary",
        isOpen: isOpen,
        onModalClose: handleOnClose
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", {
        className: "modal-secondary__header-container"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "modal-secondary__header-left-section"
    }, showBackButton ? /*#__PURE__*/ React.createElement("button", {
        onClick: handleClickBackButton,
        "aria-label": getLabel('common.actions.close')
    }, /*#__PURE__*/ React.createElement(Icon, {
        className: "modal-secondary__header-icon-button modal-secondary__header-icon-button--left",
        name: "chevron-left"
    })) : null, /*#__PURE__*/ React.createElement(Heading, {
        className: "modal-secondary__title",
        variant: "smallest"
    }, title)), headerTextButtonProps ? /*#__PURE__*/ React.createElement(HeaderTextButton, swcHelpers.extends({}, headerTextButtonProps)) : null, showCloseButton && !headerTextButtonProps ? /*#__PURE__*/ React.createElement("button", {
        onClick: handleClickCloseButton,
        "aria-label": getLabel('common.actions.close')
    }, /*#__PURE__*/ React.createElement(Icon, {
        className: "modal-secondary__header-icon-button",
        name: "close"
    })) : null), children), /*#__PURE__*/ React.createElement("div", {
        className: "modal-secondary__footer"
    }, footer));
};

export { Modal as default };
//# sourceMappingURL=Modal.js.map
